import { render } from "./LegalInfo.vue?vue&type=template&id=1bd2f0d0&scoped=true"
import script from "./LegalInfo.vue?vue&type=script&lang=js"
export * from "./LegalInfo.vue?vue&type=script&lang=js"

import "./LegalInfo.vue?vue&type=style&index=0&id=1bd2f0d0&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd2f0d0"]])

export default __exports__